
<script>
import { getAuth, updateProfile } from 'firebase/auth';
import {
  doc,
  updateDoc,
  getFirestore,
  serverTimestamp,
} from 'firebase/firestore';
export default {
  name: 'StrappOnboardingPopup',

  data() {
    return {
      handyAttachments: [],
      e1: 1,
      mobileDialog: true,
      checked: false,
      selected: '',
      count: 0,
      disabled: false,
      phone: '',
      suburb: '',
      bio: '',
      image: '',
      interests: [
        { name: 'Film & Photography', checked: false, disabled: false },
        { name: 'Audio Visual Equipment', checked: false, disabled: false },
        { name: 'Projectors and Screens', checked: false, disabled: false },
        { name: 'Drones', checked: false, disabled: false },
        { name: 'DJ Equipment', checked: false, disabled: false },
        { name: 'Transport', checked: false, disabled: false },
        { name: 'Storage', checked: false, disabled: false },
        { name: 'Electronics', checked: false, disabled: false },
        { name: 'Party and Events', checked: false, disabled: false },
        { name: 'Sports', checked: false, disabled: false },
        { name: 'Music', checked: false, disabled: false },
        { name: 'Home, Office and Garden', checked: false, disabled: false },
        { name: 'Kids and Baby', checked: false, disabled: false },
        { name: 'Holiday and Travel', checked: false, disabled: false },
        { name: 'Clothing', checked: false, disabled: false },
      ],
      selectedInterests: [],
    };
  },

  components: {
    UploadAvatar: () => import('@/components/Profile/UploadAvatar.vue'),
  },

  computed: {
    authUser() {
      const auth = getAuth();
      console.log(auth.currentUser);
      return auth.currentUser;
    },
  },

  methods: {
    methods: {
      /**
       * When the location found
       * @param {Object} addressData Data of the found location
       * @param {Object} placeResultData PlaceResult object
       * @param {String} id Input container ID
       */
      getAddressData: function (addressData, placeResultData, id) {
        this.address = addressData;
      },
    },
    increase: function (interest) {
      //changing the value of checked to add the blue class, with this class I add
      // the background color to the button as if it was active.
      interest.checked = !interest.checked;

      if (interest.checked) {
        this.count++;
      } else {
        this.count--;
        ``;
      }
    },
    check() {
      //get list of selected interests
      for (let i = 0; i < this.interests.length; i++) {
        if (this.interests[i].checked) {
          this.selectedInterests.push(this.interests[i].name);
        }
      }
      return this.selectedInterests;
    },

    async uploadOnboarding() {
      this.dialogLoading = true;

      //get selected interests

      const db = getFirestore();

      const userRef = doc(db, 'users', this.$store.getters.user.id);

      var interests = await this.check();

      // Set the "capital" field of the city 'DC'
      await updateDoc(userRef, {
        bio: this.bio,
        timestamp: serverTimestamp(),
        phone: this.phone,
        suburb: this.suburb,
        interests: interests,
        avatar: this.image,
      });
    },
  },
  watch: {
    count: function (n, o) {
      if (this.count > 9) {
        for (let i = 0; i < this.interests.length; i++) {
          if (!this.interests[i].checked) {
            this.interests[i].disabled = true;
          } else {
            this.interests[i].disabled = false;
          }
        }
      } else {
        for (let i = 0; i < this.interests.length; i++) {
          this.interests[i].disabled = false;
        }
      }
    },
  },
};
</script>

<template>
  <div>
    <v-dialog
      style="border-radius: 12px !important"
      v-model="mobileDialog"
      persistent
      width="50%"
      height="50%"
    >
      <v-card style="border-radius: 12px !important" class="text-center">
        <v-divider></v-divider>
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1"> 1 </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2"> 2 </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3"> 3 </v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step step="4"> 4</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <div class="grid">
                <base-img
                  :src="require('@/assets/logos/icon1.svg')"
                  class="mb-5 mt-2 mx-auto"
                  contain
                  height="100"
                  width="382"
                />

                <v-card-title class="text-h5">
                  Welcome to Strapp!
                </v-card-title>
                <v-card-title class="text-body-2 text-wrap">
                  A community of people who share their stuff with each
                  <br />other. We are here to help you save money and get access
                  <br />to what you need safely.
                </v-card-title>

                <v-card-actions class="mt-4">
                  <v-btn color="primary" @click="e1 = 2"> Continue </v-btn>
                  <v-btn text> Cancel </v-btn>
                </v-card-actions>
              </div>
            </v-stepper-content>
            <v-stepper-content step="2">
              <div class="grid pa-1">
                <v-card-title class="text-subtitle-2"
                  >A few words about youself? (this can always be updated later
                  on)
                </v-card-title>

                <!-- <upload-avatar v-if="!image" @submit="handleImageUpload" /> -->

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-textarea
                      width="100vw"
                      v-bind="attrs"
                      v-on="on"
                      class="round"
                      solo
                      v-model="bio"
                      name="input-7-4"
                      onkeypress="return ^[a-zA-Z0-9_]+( [a-zA-Z0-9_]+)*$i.test(event.key)"
                      counter
                      maxlength="250"
                      label="I love Strapp etc..."
                    >
                      <template v-slot:progress>
                        <v-progress-linear
                          type="text"
                          :description="progress"
                          :color="color"
                          :value="progress"
                          absolute
                          height="7"
                        />
                      </template>
                    </v-textarea>
                  </template>
                  <span>150 characters max, no contact numbers or emails.</span>
                </v-tooltip>

                <v-card-actions class="mt-4">
                  <v-btn color="primary" @click="e1 = 3"> Continue </v-btn>
                  <v-btn text> Cancel </v-btn>
                </v-card-actions>
              </div>
            </v-stepper-content>

            <v-stepper-content step="3">
              <div class="grid pa-1">
                <v-card-title class="text-subtitle-2"
                  >What kinds of items would you like to rent or borrow? <br />
                  {{ this.count }}/10</v-card-title
                >
                <v-card-title class="text-body-2"></v-card-title>

                <v-row>
                  <div class="interests__content">
                    <v-tooltip
                      color="primary"
                      top
                      v-for="interest in interests"
                      :key="interest.name"
                    >
                      <template v-slot:activator="{ props }">
                        <v-btn
                          v-model="selected"
                          v-bind="props"
                          outlined
                          tile
                          slot="activator"
                          :class="{
                            original: interest.checked,
                            interest__btn: !interest.checked,
                          }"
                          class="ma-1"
                          @click="increase(interest)"
                          :disabled="interest.disabled"
                          :checked="checked"
                          >{{ interest.name }}</v-btn
                        >
                      </template>
                    </v-tooltip>
                  </div>
                </v-row>

                <v-card-actions class="mt-4">
                  <v-btn color="primary" @click="e1 = 4"> Continue </v-btn>
                  <v-btn text> Cancel </v-btn>
                </v-card-actions>
              </div>
            </v-stepper-content>

            <v-stepper-content step="4">
              <div class="grid">
                <p class="subtitle-2 my-3 ml-auto mr-auto">Almost There!</p>
                <v-card-text>
                  To facilitate the Strapp rental process we require your
                  location and mobile number.
                  <br /><br />
                  <v-text-field
                    outlined
                    id="phone"
                    v-model="phone"
                    block
                    name="phone number"
                    style="border-radius: 8px"
                    label="Phone Number"
                    required
                  />

                  <!-- <vuetify-google-autocomplete
                    id="map"
                    append-icon="search"
                    v-bind:disabled="true"
                    placeholder="Please type your address"
                    v-on:placechanged="getAddressData"
                    country="za"
                  >
                  </vuetify-google-autocomplete> -->

                  <v-text-field
                    outlined
                    id="suburb"
                    v-model="suburb"
                    block
                    name="suburb"
                    style="border-radius: 8px"
                    label="Suburb"
                    required
                  />
                </v-card-text>

                <v-card-actions>
                  <v-btn
                    color="primary"
                    @click="uploadOnboarding()"
                    :disabled="phone == '' || suburb == ''"
                  >
                    Submit
                  </v-btn>
                  <v-btn text @click="e1 = 1"> Cancel </v-btn>
                </v-card-actions>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
  </div>
</template>


<style>
.round {
  border-radius: 12px;
}
</style>

